
export const availableMoveSizes = [
    {"id": "", "value": "House", "icon": "icon-house.svg"},
    {"id": "", "value": "Condo", "icon": "icon-condo.svg"},
    {"id": "", "value": "Apartment", "icon": "icon-apartment.svg"}
  ];